import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconsModule } from '../../icons/icons.module';
import { FlightSummaryComponent } from './flight-summary.component';

@NgModule({
  declarations: [FlightSummaryComponent],
  imports: [CommonModule, IconsModule],
  exports: [FlightSummaryComponent],
})
export class FlightSummaryModule {}
